import {useEffect} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {modalStatsHit} from "../../tracking/algolytics_hits/modal_stats_hit";
import {closeForYouModal} from "../state/for_you_modal_slice";
import {ForYouFormDisplayGtmEvent} from "../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouModalStep} from "../types/ForYouModalStep";
import {getDisplayEventFromState} from "../utils/get_display_event_from_state";
import {ForYouModalContent} from "./modal_parts/ForYouModalContent";
import {ForYouModalHeading} from "./modal_parts/ForYouModalHeading";

export const ForYouModal = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const viewType = useAppSelector((state) => state.viewType);
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (modalState.isModalOpen && isMobile) {
            document.body.style.overflow = "hidden";
        }

        if (!modalState.isModalOpen && isMobile) {
            document.body.removeAttribute("style");
        }
    }, [modalState.isModalOpen]);

    const onModalClose = () => {
        const gtmEvent = getDisplayEventFromState(modalState.step);
        if (gtmEvent) {
            ForYouFormDisplayGtmEvent({
                event: gtmEvent,
                action: ForYouDisplayActions.CLOSE,
                region: modalState.mainRegionName,
                openFrom: modalState.openFrom
            });
        }

        const wasSubmit = [ForYouModalStep.ADDITIONAL, ForYouModalStep.SUMMARY, ForYouModalStep.SUCCESS].includes(modalState.step);
        if (viewType.current) {
            modalStatsHit({view_type: viewType.current, modal_version_name: "Znajdziemy dla Ciebie", used: wasSubmit});
        }
        dispatch(closeForYouModal());
    };

    return (
        <Modal isOpen={modalState.isModalOpen} css={modalStyle} onModalClose={onModalClose}>
            <div data-testid={FOR_YOU_TEST_IDS.FOR_YOU_MODAL}>
                <Modal.Header as="div" showCloseButton={false}>
                    <ForYouModalHeading onModalClose={onModalClose} />
                </Modal.Header>
                <Modal.Content className="modal-content">
                    <ForYouModalContent />
                </Modal.Content>
            </div>
        </Modal>
    );
};

const modalStyle = css`
    .modal-content {
        ${p(0)};
    }

    @media (min-width: ${getThemeBreakpoint().sm}) {
        max-width: 840px;
        width: 100%;
    }
`;
import {useEffect} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {modalStatsHit} from "../../tracking/algolytics_hits/modal_stats_hit";
import {closeForYouModal} from "../state/for_you_modal_slice";
import {ForYouFormDisplayGtmEvent} from "../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../types/ForYouDisplayActions";
import {ForYouModalStep} from "../types/ForYouModalStep";
import {getDisplayEventFromState} from "../utils/get_display_event_from_state";
import {ForYouModalContent} from "./modal_parts/ForYouModalContent";
import {ForYouModalHeading} from "./modal_parts/ForYouModalHeading";

export const ForYouModal = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const viewType = useAppSelector((state) => state.viewType);
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (modalState.isModalOpen && isMobile) {
            document.body.style.overflow = "hidden";
        }

        if (!modalState.isModalOpen && isMobile) {
            document.body.removeAttribute("style");
        }
    }, [modalState.isModalOpen]);

    const onModalClose = () => {
        const gtmEvent = getDisplayEventFromState(modalState.step);
        if (gtmEvent) {
            ForYouFormDisplayGtmEvent({
                event: gtmEvent,
                action: ForYouDisplayActions.CLOSE,
                region: modalState.mainRegionName,
                openFrom: modalState.openFrom
            });
        }

        const wasSubmit = [ForYouModalStep.ADDITIONAL, ForYouModalStep.SUMMARY, ForYouModalStep.SUCCESS].includes(modalState.step);
        if (viewType.current) {
            modalStatsHit({view_type: viewType.current, modal_version_name: "Znajdziemy dla Ciebie", used: wasSubmit});
        }
        dispatch(closeForYouModal());
    };

    return (
        <Modal isOpen={modalState.isModalOpen} css={modalStyle} onModalClose={onModalClose}>
            <div data-testid={FOR_YOU_TEST_IDS.FOR_YOU_MODAL}>
                <Modal.Header as="div" showCloseButton={false}>
                    <ForYouModalHeading onModalClose={onModalClose} />
                </Modal.Header>
                <Modal.Content className="modal-content">
                    <ForYouModalContent />
                </Modal.Content>
            </div>
        </Modal>
    );
};

const modalStyle = css`
    .modal-content {
        ${p(0)};
    }

    @media (min-width: ${getThemeBreakpoint().sm}) {
        max-width: 840px;
        width: 100%;
    }
`;
